import {
  API,
  ASSIST,
  EMAIL,
  SLACK,
  VOICE,
  WEB_CALL,
  WIDGET,
} from '../constants';
import { ProductMode } from '../types';
import { useIsInAssist, useStateParams } from 'src/hooks/hooks';

export default function useProductMode() {
  const isAssistRoute = useIsInAssist();

  const [productMode, setProductMode] = useStateParams<ProductMode>({
    deserialize: item => {
      switch (item) {
        case 'voice':
          return VOICE;
        case 'email':
          return EMAIL;
        case 'assist':
          return ASSIST;
        case 'api':
          return API;
        case 'slack':
          return SLACK;
        case 'web_call':
          return WEB_CALL;
        default:
          return WIDGET;
      }
    },
    initialState: isAssistRoute ? ASSIST : WIDGET,
    paramsName: 'product_mode',
    serialize: item => item,
  });

  return [productMode, setProductMode] as const;
}
